import { jsxs as p, jsx as r } from "react/jsx-runtime";
import { clsx as A } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { formatRequiredLabel as O } from "../../utils/label-formatter.js";
import { RocheUIIcon as R } from "../icon/roche-icon.js";
import { RocheUITooltip as Z } from "../tooltip/roche-tooltip.js";
import e from "./roche-input.module.scss.js";
import { RocheUIInputType as u } from "./roche-input.types.js";
const D = "16px", W = ({
  id: n,
  label: l,
  value: s,
  placeholder: I,
  required: o = !1,
  tooltip: f,
  tooltipAriaLabel: S,
  type: c = u.TEXT,
  maxLength: b,
  hint: d,
  error: N,
  disabled: h = !1,
  hasMarginTop: y = !0,
  minRows: a,
  maxRows: m,
  translations: t,
  valid: L,
  dirty: U,
  hintParsed: $,
  onBlur: C,
  onChange: _
}) => {
  const i = U && !L, E = `${n}-error`, x = `${n}-hint`, T = c === u.TEXTAREA && (a !== void 0 || m !== void 0), j = T ? {
    ...a !== void 0 && { "--roche-input-min-rows": a },
    ...m !== void 0 && { "--roche-input-max-rows": m }
  } : void 0, z = A(
    e.input,
    i && e["input--error"],
    h && e["input--disabled"],
    !y && e["input--no-margin"]
  ), X = !!(l || o || d), g = [d && x, i && E].filter(Boolean).join(" "), B = (v) => {
    _(v.target.value);
  }, H = (v) => {
    _(v.target.value);
  }, k = () => {
    _("");
  }, w = () => c === u.SEARCH && s ? /* @__PURE__ */ r(
    "button",
    {
      className: e["input__clear-button"],
      onClick: k,
      "aria-label": t == null ? void 0 : t.clearInput,
      type: "button",
      children: /* @__PURE__ */ r(R, { icon: "cross", height: D })
    }
  ) : null, F = () => /* @__PURE__ */ p("div", { className: e.input__wrapper, children: [
    c !== u.TEXTAREA ? /* @__PURE__ */ r(
      "input",
      {
        id: n,
        className: e.input__input,
        maxLength: b || void 0,
        placeholder: I,
        disabled: h,
        value: s,
        required: o,
        "aria-invalid": i,
        "aria-describedby": g || void 0,
        onBlur: C,
        onChange: B,
        type: c
      }
    ) : /* @__PURE__ */ r(
      "textarea",
      {
        id: n,
        className: A(e.input__input, T && e["input__input--auto-size"]),
        style: j,
        maxLength: b || void 0,
        required: o,
        placeholder: I,
        disabled: h,
        value: s,
        "aria-invalid": i,
        "aria-describedby": g || void 0,
        onBlur: C,
        onChange: H,
        rows: a ?? 5
      }
    ),
    w()
  ] });
  return /* @__PURE__ */ p("div", { className: z, children: [
    X && /* @__PURE__ */ p("div", { className: e["input__label-wrapper"], children: [
      /* @__PURE__ */ r("label", { className: e.input__label, htmlFor: n, children: O(o, l) }),
      f && /* @__PURE__ */ r(Z, { ariaLabel: S, children: f }),
      d && /* @__PURE__ */ r("span", { id: x, className: e.input__hint, children: $ })
    ] }),
    F(),
    i && /* @__PURE__ */ p("div", { id: E, className: e.input__error, ...i && { role: "alert" }, children: [
      /* @__PURE__ */ r(R, { icon: "info", width: "16px", decorative: !0 }),
      /* @__PURE__ */ r("p", { className: e["input__error-text"], children: N || `${t == null ? void 0 : t.error} ${l}` })
    ] })
  ] });
};
export {
  W as RocheUIInput
};
